import { gameState, config } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    config.audio.bgaudio = this.sound.add('bgaudio').setLoop(true).setVolume(0.02);

    config.audio.correctAnswer = this.sound.add('correctAnswer').setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add('wrongAnswer').setVolume(0.05);

    config.audio.hover = this.sound.add('hover').setVolume(0.05);
    config.audio.watering = this.sound.add('watering').setVolume(0.05).setSeek(5000);

    config.audio.sunShining = this.sound.add('sunShining').setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add('flowerBlossoming').setVolume(0.05);

    config.audio.ta1 = this.sound.add('ta1').setVolume(0.05);
    config.audio.ta2 = this.sound.add('ta2').setVolume(0.05);
    config.audio.ta3 = this.sound.add('ta3').setVolume(0.05);
    config.audio.ta4 = this.sound.add('ta4').setVolume(0.05);

    this.anims.create({
      key: 'plantmove',
      frames: this.anims.generateFrameNames('plant', {
        start: 0,
        end: 37,
        prefix: 'plantssway',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.sbg = this.add.image(0, 0, 'sbg').setOrigin(0);

    const plantPositions = [
      [527, 151], [780, 351], [720, 430], [618, 462], [523, 448],
      [574, 399], [451, 348], [519, 253], [460, 184], [757, 227],
      [746, 378], [583, 106], [635, 133], [583, 200], [679, 217],
      [734, 130],
    ];
    plantPositions.forEach(([x, y]) => {
      this.add.sprite(x, y, 'plant').setOrigin(0).setScale(0.2).play('plantmove');
    });

    this.playButton = this.add
      .image(529, 592, 'play_button')
      .setInteractive({ cursor: 'pointer' })
      .setOrigin(0, 0);

    this.playButton.on('pointerover', () => {
      this.playButton.setTexture('play_button_on');
    });

    this.playButton.on('pointerout', () => {
      this.playButton.setTexture('play_button');
    });

    this.playButton.on('pointerdown', () => {
      config.audio.bgaudio.play();

      this.playButton.setScale(0);

      this.time.delayedCall(500, () => {
        disablePointerEvents();
        this.scene.launch('HintScene');
        this.scene.launch('GameScene');
        this.scene.stop('StartScene');
      });
    });
  }

  update() {}
}
